export class Vector3 {
  public onChange: ((vector: Vector3) => void) | null = null;

  private _x: number;
  private _y: number;
  private _z: number;

  get x(): number {
    return this._x;
  }

  set x(newValue: number) {
    if (this._x === newValue) return;
    this._x = newValue;
    this.onChange && this.onChange(this);
  }

  get y(): number {
    return this._y;
  }

  set y(newValue: number) {
    if (this._y === newValue) return;
    this._y = newValue;
    this.onChange && this.onChange(this);
  }

  get z(): number {
    return this._z;
  }

  set z(newValue: number) {
    if (this._z === newValue) return;
    this._z = newValue;
    this.onChange && this.onChange(this);
  }

  constructor(x: number = 0, y: number = 0, z: number = 0) {
    this.set(x, y, z);
  }

  public set(x: number, y: number, z: number) {
    if (this._x === x && this._y === y && this._z === z) return;
    this._x = x;
    this._y = y;
    this._z = z;
    this.onChange && this.onChange(this);
  }

  public setSilent(x: number, y: number, z: number) {
    this._x = x;
    this._y = y;
    this._z = z;
  }

  public toString(): string {
    return `${this._x}x${this._y}x${this._z}`;
  }
}